import { useEffect, useState } from "react";
import Style from "./style.module.css";
import InnerLoader from "../../../../component/ui/loader/inner-loader";
import DataNotFound from "../../../../component/ui/loader/data-not-found";
import { PlusIcon } from "lucide-react";
import { useApiCall } from "../../../../component/custom-hooks/api-call";
import { Alert, Snackbar } from "@mui/material";
import { Table, TableBody, TableCard, TableCell, TableHead, TableHeaderWrap, TableRow } from "../../../../component/table/table-layout";
import Tooltip from "../../../../component/ui/tooltip";
import NewEditIcon from "../../../../component/icons/action-edit-icon";
import StatusChip from "../../../../component/ui/chip/status";
import { TitleHeading } from "../../../../component/ui/layout";
import OfficeAssetsConfigPopup from "../popup";

const OfficeAssetsCategory = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [lists, setList] = useState([]);
  const [alertData, setAlertData] = useState({ isShow: false });
  const [currentData, setCurrentData] = useState({});
  const [addModal, setAddModal] = useState(false);
  const [tabIndex, setTabIndex] = useState(null);

  const handleClose = () => {
    setAlertData({ isShow: false });
  };

  const apiCall = useApiCall();

  useEffect(() => {
    getData({});
  }, []);

  const getData = async () => {
    setIsLoading(true);
    try {
      const res = await apiCall({ method: "get", url: `office-asset/categories/list` });
      setList(res.data);
      setIsLoading(false);
    } catch (error) {
      console.warn("Error : ", error);
    }
  };

  const onSuccess = (message) => {
    setAlertData({ isShow: true, type: "success", message: message });
    getData();
  };

  const onError = (message) => {
    setAlertData({ isShow: true, type: "error", message: message });
  };

  const editDetail = (ele) => {
    setTabIndex(0);
    setCurrentData(ele);
    setAddModal(true);
  };

  return (
    <>
      <div className={Style.leaveMainPage}>
        <div className={Style.report_table__header}>
          <span className={Style.report_table__title}>
            <TitleHeading title={`Categories`} />
          </span>

          <div className={Style.bpfl_action} onClick={() => { setAddModal(true); }}>
            <Tooltip
              content={"Add Category"}
              position={"left center"}
              className={`${Style.bpfl_actionBtn} ${Style.addBtn}`}
            >
              <div className={Style.icon}>
                <PlusIcon size={'1em'} />
              </div>
            </Tooltip>
          </div>
        </div>

        <div className={Style.LeaveBody}>
          {isLoading ? (
            <InnerLoader />
          ) : !lists?.length ? (
            <DataNotFound title={"Categories"} />
          ) : (
            <>
              <TableCard>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell header sticky><TableHeaderWrap><span>Category Key</span></TableHeaderWrap></TableCell>
                      <TableCell header><TableHeaderWrap><span>Category Label</span></TableHeaderWrap></TableCell>
                      <TableCell header><TableHeaderWrap><span>Status</span></TableHeaderWrap></TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {lists?.map((eachList, index) => {
                      return (
                        <TableRow key={`${index}`}>
                          <TableCell sticky>
                            <div className={`${Style.tableActionArea} !gap-4`}>
                              <div className="flex gap-[10px]">
                                <div className="flex items-center gap-3">
                                  <div className="font-semibold text-[15px] leading-5">{eachList?.category_key}</div>
                                </div>
                              </div>

                              <div className={Style.tableActionAreaBtnGrpup}>
                                <div onClick={() => { editDetail(eachList) }} className={"w-7 h-7 flex items-center justify-center rounded-md bg-[rgba()] shadow-[0_4px_12px_rgba(0,0,0,0.08)] border border-gray-100 hover:scale-105 transition-transform duration-300"}>
                                  <div
                                    className={Style.icon}
                                    style={{ color: "#FF9500" }}
                                  >
                                    <NewEditIcon className="h-4.5 w-4.5" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </TableCell>
                          <TableCell>{eachList?.category_label}</TableCell>
                          <TableCell>
                            {
                              eachList?.is_active ? (
                                <StatusChip color="green">Active</StatusChip>
                              ) : (
                                <StatusChip color="red">In Active</StatusChip>
                              )
                            }
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableCard>
            </>
          )}
        </div>
      </div>

      {
        addModal && (
          <OfficeAssetsConfigPopup
            onClose={() => { setAddModal(false); setCurrentData({}); setTabIndex(null); }}
            onError={onError}
            onSuccess={onSuccess}
            onSubmit={() => { setAddModal(false); setCurrentData({}); setTabIndex(null); }}
            currentData={currentData}
            // tabIndex={tabIndex}
          />
        )
      }

      <Snackbar
        open={alertData?.isShow}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={alertData?.type}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {alertData?.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default OfficeAssetsCategory;
